<template>
  <v-form ref="form" class="">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />
    
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="entry.name"
          v-bind="getObject('name')"
          label="Nome"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12">
        <v-autocomplete
          v-model="entry.groupType"
          v-bind="getObject('groupType')"
          label="Tipo de Grupo"
          :items="extraData.accountContext.allAccountGroupTypes"
          item-value="value"
          item-text="text"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
  }
};
</script>

<style scoped></style>
